import {
  Component,
  EventEmitter,
  Input,
  Output,
  booleanAttribute,
} from '@angular/core';

@Component({
  selector: 'sigecom-selected-card',
  template: `
    <section
      class="flex min-h-[5rem] items-center gap-3 rounded-md border border-sigecom-info bg-sigecom-info/10 px-4 py-3 text-sigecom-dark-gray"
      [class.opacity-60]="disabled"
    >
      <div class="min-w-0 flex-1">
        <p class="mb-1 text-sm font-bold text-sigecom-info">
          {{ label }}
          <span *ngIf="isRequired" class="text-sigecom-danger">*</span>
        </p>
        <p class="truncate text-sm" [title]="value || emptyMessage">
          {{ value || emptyMessage }}
        </p>
        <p *ngIf="description" class="mt-1 text-xs text-sigecom-gray">
          {{ description }}
        </p>
      </div>

      <div *ngIf="value" class="flex shrink-0 items-center gap-1">
        <button
          *ngIf="editable"
          type="button"
          class="flex h-8 w-8 items-center justify-center rounded-md text-sigecom-info transition-colors hover:bg-sigecom-info/20 disabled:cursor-not-allowed disabled:opacity-50"
          title="Editar seleção"
          [disabled]="disabled"
          (click)="edit.emit()"
        >
          <fa-icon icon="pen"></fa-icon>
        </button>
        <button
          *ngIf="removable"
          type="button"
          class="flex h-8 w-8 items-center justify-center rounded-md text-sigecom-danger transition-colors hover:bg-sigecom-danger/10 disabled:cursor-not-allowed disabled:opacity-50"
          title="Remover seleção"
          [disabled]="disabled"
          (click)="remove.emit()"
        >
          <fa-icon icon="trash"></fa-icon>
        </button>
      </div>
    </section>
  `,
})
export class SelectedCardComponent {
  @Input() label = 'Item selecionado';
  @Input() value?: string | null;
  @Input() description?: string | null;
  @Input() emptyMessage = 'Nenhum item selecionado.';
  @Input({ transform: booleanAttribute }) isRequired = false;
  @Input({ transform: booleanAttribute }) editable = false;
  @Input({ transform: booleanAttribute }) removable = false;
  @Input({ transform: booleanAttribute }) disabled = false;

  @Output() edit = new EventEmitter<void>();
  @Output() remove = new EventEmitter<void>();
}